module.exports = __webpack_public_path__ + "static/media/xls.233c3905.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/xls.png
// module id = 695
// module chunks = 0